export enum AdminRulesStatus {
    ENABLE = 1,
    DISABLE = 2
}

export enum UserBannStatus {
    NOT_BANNED = 1,
    BANNED = 2
  }